export enum ToastThemeType {
    LIGHT = "light",
    DARK = "dark",
    COLORED = "colored",
}
